import { Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { onlyNumbers } from 'Regex';

interface IClause {
  title: string;
  information: string;
}

export const Clause = ({ title, information }: IClause) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack width='auto' gap={isDesktop ? '8px' : '4px'}>
      <Typography variant={'body6'} component='h3'>
        {title}
      </Typography>
      <Typography variant={'body2'}>
        {information
          ? onlyNumbers.test(information)
            ? `${Number(information)}%`
            : information
          : ''}
      </Typography>
    </Stack>
  );
};
